import menu from './menu'
import table from './table'
export default {
    statisticProcesses: 'Statistik',
    statisticSurvey: 'Erhebung',
    statisticSurveyPeriod: 'Erhebungszeitraum',
    statisticSurveyRecordingPeriod: 'Erfassungszeitraum',
    statisticProcessCount: '{count} Statistiken|{count} Statistik|{count} Statistiken',
    statisticForm: 'Statistikformular',

    dedicatedProcess: 'Zugehöriger Vorgang',
    forStatisticSurveyPeriod: 'Für den Erhebungszeitraum',
    name: 'Interner Name',
    event_id: 'Veranstaltungs-ID',
    organisation_id: 'Organisations-ID',
    creator_user_id: 'Ersteller*in-ID',
    statistic_formable_id: 'Statistikformular-ID',
    statistic_formable_type: 'Statistikformular-Typ',
    statistic_survey_period_id: 'Erhebungszeitraum-ID',
    status_id: 'Status-ID',

    addNewStatistic: 'Neue Statistik hinzufügen',
    createStatistic: 'Statistik erstellen',
    deleteStatisticProcess: 'Statistik löschen',
    deleteStatisticProcessText: 'Möchtest du die Statistik wirklich löschen?',
    deleteStatisticProcessSuccess: 'Statistik erfolgreich gelöscht',
    deleteStatisticProcessError: 'Statistik konnte nicht gelöscht werden',

    createSuccess: 'Statistik erfolgreich erstellt',
    createError: 'Statistik konnte nicht erstellt werden',
    saveSuccess: 'Statistik erfolgreich gespeichert',
    saveError: 'Statistik konnte nicht gespeichert werden',

    statisticProcessId: 'Statistik "{id}"',

    statisticFormLocked: 'Die Statistik ist gesperrt.',
    statisticFormLockedText: 'Die Statistik wurde abgeschickt und kann nicht weiter bearbeitet werden.',

    statisticProcessNavigator: {
        saveDraft: 'Entwurf speichern',
    },

    menu,
    table,
}